module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_10X_Section1.064c5e97.png";